module.exports = __webpack_public_path__ + "static/media/ProjectsIcon.75c3f458.svg";